import axios from 'axios'
import qs from "qs";
import Vue from 'vue'
import router from './router'
import { Message, Loading } from 'element-ui';
const baseURL = process.env.NODE_ENV === 'production' ? process.env.BASE_API : "/jhSeal"
const http = axios.create({
  baseURL: "/jhSeal",
})
let loading
function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

http.interceptors.request.use(function (config) {
  if (localStorage.token) {
    config.headers.Authorization = sessionStorage.token
  }
  if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
    if (config.headers['Content-Type'] !== 'application/json;charset=UTF-8') {
      config.data = qs.stringify(config.data)
    }
  }
  showFullScreenLoading()
  return config
}, function (error) {
  console.log(error)
  // Do something with request error
  return Promise.reject(error);
});

// 设置全局捕获错误  拦截器
http.interceptors.response.use(res => {
  if (res.data.code == -2) {
    router.push('/login')
  }
  tryHideFullScreenLoading()
  return res

}, err => {
  console.log(err);
  endLoading()
  // if (err.response.data.message) {
  //   Vue.prototype.$message({
  //     type: 'error',
  //     message: err.response.data.message
  //   })

  //   if(err.response.status === 401){
  //     router.push('/login')
  //   }
  // }

  return Promise.reject(err)
})
export default http



// WEBPACK FOOTER //
// ./src/http.js